module.exports = __webpack_public_path__ + "/images/ico-color-mobile.7041ab8.svg";